export function getTotalLengthPerPage<T>(pages: { data: T[] }[]): number {
  return pages.reduce((total, page) => total + page.data.length, 0);
}
